/**
 * 售后中心-评价管理
 */

import { post, get, deleteApi, postJson, postUrl } from '../axios'

const RESOURCE_BASE_PATH = '/popComment/'

// 统计短信条数
export const smsCount = p => postJson(`${RESOURCE_BASE_PATH}InfopopCommentSmsrecord`, p);

// 获取未评价的订单
export const getNoPopCommentOrderList = p => get(`${RESOURCE_BASE_PATH}getNoPopCommentOrderList`, p);

// 获取评价回复列表
export const getPopCommentReplyList = p => get(`${RESOURCE_BASE_PATH}getPopCommentReplyList`, p);

// 评价监控
export const monitor = p => get(`${RESOURCE_BASE_PATH}monitor`, p);

// 导出订单
export const exportOrder = p => postJson(`${RESOURCE_BASE_PATH}popCommentExportOrderList`, p);

// 编辑备注
export const editRemark = p => postUrl(`${RESOURCE_BASE_PATH}savePopCommentRemark`, p);

// 获取催评链接
export const getShortLink = p => get(`/shortLink/`, p);

// 批量回评
export const replyCommentBatch = p => postJson(`/manualReplyComment/replyCommentBatch`, p); 